<template>
    <div >
        <div class="container">
            <div class="row">
                <div class="col s12 m8 offset-m2">
                    <div class="login card-panel green white-text center">
                        <h3>Login</h3>
                        <form action="">
                            <div class="input-field">
                                <i class="material-icons prefix">email</i>
                                <input type="text" id="email" v-model='email'>
                                <label class="white-text" for="email">Email</label>
                            </div>
                            <div class="input-field">
                                <i class="material-icons prefix">lock</i>
                                <input type="password" id="password" v-model='password'>
                                <label class="white-text" for="password">Password</label>
                            </div>
                            <div>
                                <p v-if='errorFlag' class="red-text lighten-2">{{errorMsg}}</p>
                            </div>
                            <button v-on:click="login" type="submit" class="btn btn-large grey lighten-4 black-text">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import db from 'firebase'; 

export default{
    name: 'login',
    data: function(){
        return{
            email: '',
            password: '',
            errorFlag: false,
            errorMsg: ''
        };
    },
    methods: {
        login: function(e){
            db.auth().signInWithEmailAndPassword(this.email ,this.password).then(
                user => {
                    alert(`You are logined as ${user.user.email}`);
                    this.$router.go({path: this.$router.path});
                },
                err =>{
                    //alert(err.message);
                    this.errorFlag = true;
                    this.errorMsg = err.message;
                }
            );
            e.preventDefault();                
        }
    }
}
</script>
<style>
input{
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue